import { render } from "./activityLog.vue?vue&type=template&id=22febd60"
import script from "./activityLog.vue?vue&type=script&lang=js"
export * from "./activityLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__